import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

const getMyyolaUrl = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'common.myyola.url');
  }

  return get(cfg, 'common.myyola.wl_url');
};

export default getMyyolaUrl;
